import { SMSAutoResponse } from 'domains/content/types';
import SmsMessageInput from 'pages/ContentSmsBuilderPage/components/SmsMessageInput';

type Props = {
    autoResponse: SMSAutoResponse;
    updateAutoResponse: (autoResponse: SMSAutoResponse) => void;
};

const FollowUpMessageInput = ({ autoResponse, updateAutoResponse }: Props) => {
    const setMessage = (text: string) => {
        const updatedAutoResponse = {
            ...autoResponse,
            text,
        };

        updateAutoResponse(updatedAutoResponse);
    };

    return (
        <SmsMessageInput
            label="Follow-Up Message"
            isContentLoading={false}
            message={autoResponse.text ?? ''}
            rows={5}
            setMessage={setMessage}
            width="100%"
        />
    );
};

export default FollowUpMessageInput;
